import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
    selector: 'lib-chips-wrapper',
    templateUrl: './chips-wrapper.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChipsWrapperComponent {
	@HostBinding('style') style = 'display: block';
}
